import React, { useContext } from 'react';
import ProcanvasSlider from '../../../../../common/procanvasSlider';
import { MarkupContext } from '../../../contexts';

const ResolutionSlider = () => {
  const { resolution, updateResolution } = useContext(MarkupContext);
  return (
    <div className="form-group">
      <div className="form-label">Resolution:</div>
      <div className="form-group">
        <ProcanvasSlider
          min={ 1 }
          max={ 100 }
          step={ 1 }
          value={ resolution }
          onChange={ updateResolution }
          minLimit={ 10 }
        />
      </div>
    </div>
  );
};

export default ResolutionSlider;
